/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopOrderDetailDto } from '../../models/shop-order-detail-dto';
import { ShopOrderUpdateMemoDto } from '../../models/shop-order-update-memo-dto';

export interface ShopOrderAdminControllerUpdateMemoV1$Params {

/**
 * 주문 ID
 */
  id: string;
      body: ShopOrderUpdateMemoDto
}

export function shopOrderAdminControllerUpdateMemoV1(http: HttpClient, rootUrl: string, params: ShopOrderAdminControllerUpdateMemoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDetailDto>> {
  const rb = new RequestBuilder(rootUrl, shopOrderAdminControllerUpdateMemoV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrderDetailDto>;
    })
  );
}

shopOrderAdminControllerUpdateMemoV1.PATH = '/api/v1/shop-orders/admin/{id}/memo';
